import { ProviderDetailsAPIErrors } from 'app/ProviderSearch/constants'
import { formatInTimeZone } from 'date-fns-tz'
import callApi from 'utils/callApi'
import {
  getProviderRoute,
  PROVIDER_FILTERS,
  getProviderForPracticeRoute,
  MICROLINK_BASE_URL,
  getGeoTimezone,
  PROVIDERS,
} from './routes'
import enUS from 'date-fns/locale/en-US'
import qs from 'qs'

export enum ProviderFilterTypes {
  AVAILABILITY_TYPE = 'availability_type',
  AREA_OF_CONCERN = 'area_of_concern',
  LANGUAGE = 'language',
  COUNSELING_APPROACH = 'counseling_approach',
  CLIENT_AGE_GROUP = 'client_age_group',
  TIME_OF_DAY = 'time_of_day',
  GENDER = 'gender',
  COUNSELING_TYPE = 'counseling_type',
  TAG = 'tag',
  ORDER_BY = 'orderBy',
  INSURANCE_ID = 'insurance_id',
}

export enum ProviderHeaderFilterTypes {
  LOCATION = 'location',
  INSURANCE = 'insurance',
  B2B_CLIENT = 'b2b_client',
}

export const providerFilterKeyMapping = {
  'availabilityType[]': ProviderFilterTypes.AVAILABILITY_TYPE,
  'areaOfConcern[]': ProviderFilterTypes.AREA_OF_CONCERN,
  'gender[]': ProviderFilterTypes.GENDER,
  'clientAgeGroup[]': ProviderFilterTypes.CLIENT_AGE_GROUP,
  'language[]': ProviderFilterTypes.LANGUAGE,
  'counselingApproach[]': ProviderFilterTypes.COUNSELING_APPROACH,
  'counselingType[]': ProviderFilterTypes.COUNSELING_TYPE,
  'timeOfDay[]': ProviderFilterTypes.TIME_OF_DAY,
  insuranceId: ProviderFilterTypes.INSURANCE_ID,
}

export const getProvider = (
  queryObject: ProviderProfileQueryParams
): Promise<Provider> =>
  callApi<Provider>(
    {
      endpoint: getProviderRoute(queryObject),
      method: 'get',
    },
    (response) => {
      if (response.status === 204) {
        throw new Error(ProviderDetailsAPIErrors.PROVIDER_DELETED)
      }

      return response.data
    }
  )

export const getAllProviderDetails = (
  queryObject: ProviderProfileQueryParams
): APIResponse<ListCardProvider[]> => {
  const qsQuery = qs.stringify(queryObject, {
    addQueryPrefix: true,
    skipNulls: true,
  })

  return callApi<APIResponseSchema<ListCardProvider[]>>({
    endpoint: `${PROVIDERS}${qsQuery}`,
    method: 'get',
  })
}

export const getFilters = (state?: string): APIResponse<ProviderFilter[]> => {
  return callApi<APIResponseSchema<ProviderFilter[]>>({
    endpoint: `${PROVIDER_FILTERS}${state ? `?stateCode=${state}` : ''}`,
    method: 'get',
  })
}

export const getProvidersForPractice = (
  practiceId: string
): APIResponse<ProviderMetadataForPractice[]> => {
  return callApi<APIResponseSchema<ProviderMetadataForPractice[]>>({
    endpoint: getProviderForPracticeRoute(practiceId),
    method: 'get',
  })
}

export const getBlogMeta = (url: string): Promise<BlogMetaResponse> => {
  return callApi<BlogMetaResponse>({
    baseURL: MICROLINK_BASE_URL,
    endpoint: '',
    method: 'get',
    params: { url },
  })
}

export const fetchTimezoneFromLocation = async (
  latitude: string,
  longitude: string
): Promise<TimeZoneData> => {
  try {
    const geoTimezoneResponse = await callApi<string[]>({
      endpoint: getGeoTimezone(latitude, longitude),
    })
    const timeZoneId = geoTimezoneResponse[0]
    const timeZoneName = formatInTimeZone(new Date(), timeZoneId, 'zzzz', {
      locale: enUS,
    })

    return {
      timeZoneId,
      timeZoneName,
    }
  } catch (error) {
    return null
  }
}
